import { render, staticRenderFns } from "./StepCard.vue?vue&type=template&id=24519ff6&scoped=true"
import script from "./StepCard.vue?vue&type=script&lang=ts"
export * from "./StepCard.vue?vue&type=script&lang=ts"
import style0 from "./StepCard.vue?vue&type=style&index=0&id=24519ff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24519ff6",
  null
  
)

export default component.exports